import React, { useState } from "react";

import gallery1 from "../assets/images/gallery/IMG_1861.webp";
import gallery2 from "../assets/images/gallery/IMG_0070.webp";
import gallery3 from "../assets/images/gallery/IMG_2622.webp";
import gallery4 from "../assets/images/gallery/IMG_9830.webp";
import gallery5 from "../assets/images/gallery/IMG_1937.webp";
import gallery6 from "../assets/images/gallery/IMG_2036.webp";
import gallery7 from "../assets/images/gallery/IMG_2182.webp";
import gallery8 from "../assets/images/gallery/IMG_2531.webp";
import gallery9 from "../assets/images/gallery/IMG_2534.webp";
import gallery10 from "../assets/images/gallery/IMG_2614.webp";
import gallery11 from "../assets/images/gallery/IMG_2616.webp";
import gallery12 from "../assets/images/gallery/IMG_2619.webp";
import gallery13 from "../assets/images/gallery/IMG_3124.webp";
import gallery14 from "../assets/images/gallery/IMG_1669.webp";
import gallery15 from "../assets/images/gallery/IMG_6094.webp";
import gallery16 from "../assets/images/gallery/IMG_6158.webp";
import gallery17 from "../assets/images/gallery/IMG_6537.webp";
import gallery18 from "../assets/images/gallery/IMG_8956.webp";
import gallery19 from "../assets/images/gallery/IMG_9246.webp";
import gallery20 from "../assets/images/gallery/IMG_9925.webp";
import gallery21 from "../assets/images/Intro_image_crop_warm.webp";

function Pictures() {
  const [selectedImage, setSelectedImage] = React.useState(null);

  const galleryImages = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
    gallery17,
    gallery18,
    gallery19,
    gallery20,
    gallery21
  ];

  return (
    <div className="bg-white">
      {/* Hero */}
      <section
        className="py-32 px-6 text-center"
        style={{ background: 'linear-gradient(135deg, rgba(98, 195, 214, 0.1) 0%, rgba(211, 154, 84, 0.1) 100%)' }}
      >
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-light mb-6 text-gray-800">
            Vårt <span className="font-semibold" style={{ color: 'var(--secondary)' }}>Galleri</span>
          </h1>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((imageUrl, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer aspect-square"
                onClick={() => setSelectedImage(imageUrl)}
              >
                <img
                  src={imageUrl}
                  alt={`Behandlingsresultat ${index + 1} - Salong Milepa Helsingborg`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl w-full max-h-[90vh] flex items-center justify-center">
            {/* Close Button */}
            <button
              className="absolute -top-12 right-0 text-white text-4xl hover:text-gray-300 transition-colors z-10 bg-black/50 rounded-full w-10 h-10 flex items-center justify-center"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(null);
              }}
            >
              ×
            </button>

            {/* Image Container */}
            <div className="relative w-full h-full flex items-center justify-center">
              <img
                src={selectedImage}
                alt="Förstorad bild - Salong Milepa"
                className="max-w-full max-h-[80vh] w-auto h-auto object-contain rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      )}

      {/* CTA */}
      <section
        className="py-20 px-6"
        style={{ backgroundColor: 'var(--primary)' }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-light text-white mb-6">
            Upplev det <span className="font-semibold">Själv</span>
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Besök oss och upptäck varför våra kunder fortsätter att komma tillbaka
          </p>
          <a href="https://www.bokadirekt.se/places/salong-milepa-13263" target="_blank" rel="noopener noreferrer">
            <button
              className="px-8 py-4 rounded-full text-lg font-semibold text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
              style={{ backgroundColor: 'var(--secondary)' }}
            >
              Boka Ditt Besök
            </button>
          </a>
        </div>
      </section>
    </div>
  );
}

export default React.memo(Pictures);